import { render, staticRenderFns } from "./EditEmp.vue?vue&type=template&id=4cf56995&"
import script from "./EditEmp.vue?vue&type=script&lang=js&"
export * from "./EditEmp.vue?vue&type=script&lang=js&"
import style0 from "./EditEmp.vue?vue&type=style&index=0&id=4cf56995&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports